import { useState } from 'react';
import webApiClient from './../../Utils/webApiClient';
import { msalInstance } from '../../index';
import config from '../../Config/config';
import useRequestHandler from '../useRequestHandler';

/** Hook is used to fetch list of business units */
const useListBusinessUnits = () => {

    const [ businessUnits, setBusinessUnits ] = useState([]);
    const { errorHandler, successHandler } = useRequestHandler();
    const apiClient = webApiClient();

    /** List business units */
    const listBusinessUnits = async () => {
        try {

            // Account is set in the index.js
            const account = msalInstance.getActiveAccount();

            const response = await msalInstance.acquireTokenSilent({
                scopes: config.webApi.scopes,
                account: account
            });

            const result = await apiClient.list(response.accessToken, "businessunits");

            const data = result.data || {};
            const content = data.resultData || null;

            if (content) setBusinessUnits(content);

            return successHandler(result, "useListBusinessUnits", "list", { hide: true });

        } catch (error) {

            return errorHandler(error, "useListBusinessUnits", "list");

        }
    }

    return { businessUnits, listBusinessUnits };

}

export default useListBusinessUnits;
